import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';

type QueryConfig<TData> = {
  queryKey: readonly unknown[];
  queryFn: () => Promise<TData>;
};

type SuspenseQueryOptions<TData, TError> = Omit<
  UseQueryOptions<TData, TError, TData, readonly unknown[]>,
  'queryKey' | 'queryFn' | 'suspense' | 'useErrorBoundary'
>;

export function useSuspenseQuery<TData, TError = unknown>(
  config: QueryConfig<TData>,
  options?: SuspenseQueryOptions<TData, TError>,
) {
  return useQuery({
    ...config,
    ...options,
    suspense: true,
    useErrorBoundary: true,
  });
}
